import React from 'react';
import { Routes, Route } from 'react-router-dom';
import List from './scenes/List';
import Show from './scenes/Show';
import AdminLayout from '../../../../components/Layout/AdminLayout';

const Uploads = () => (
  <AdminLayout title="Kunduppladdningar" back>
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/:id" element={<Show />} />
    </Routes>
  </AdminLayout>
);

export default Uploads;
